module.exports = __webpack_public_path__ + "img/sx.0b915eaa.png";